module.exports = __webpack_public_path__ + "img/search.862a1183.png";